module.exports = __webpack_public_path__ + "static/hoivakotilive_slide_2-f871a3a100778d49fa364627435e1cb3.jpg";